import { memo } from 'react';

import {
  ProfileDetailsSectionHeader,
  type ProfileDetailsSectionHeaderWithDataProps,
  type ProfileDetailsSectionHeaderWithoutDataProps,
} from '@/features/profile/components/profileDetails/sectionHeader';
import { PROFILE_ICONS } from '@/features/profile/constants/icons';

export type ProfileDetailsGameplayHeaderProps =
  | Omit<
      ProfileDetailsSectionHeaderWithDataProps,
      'icon' | 'label' | 'subTitle'
    >
  | Omit<ProfileDetailsSectionHeaderWithoutDataProps, 'icon' | 'label'>;

export const ProfileDetailsGameplayHeader = memo(
  function ProfileDetailsGameplayHeader(
    props: ProfileDetailsGameplayHeaderProps,
  ) {
    const GameplayIcon = PROFILE_ICONS.gameplay;

    return (
      <ProfileDetailsSectionHeader
        {...props}
        label="Playstyle"
        icon={<GameplayIcon className="size-7" />}
      />
    );
  },
);
